export default "__VITE_ASSET__ce1acf80__"